import { render, staticRenderFns } from "./PhotoCard.vue?vue&type=template&id=b0f2b5fa&scoped=true&"
import script from "./PhotoCard.vue?vue&type=script&lang=js&"
export * from "./PhotoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f2b5fa",
  null
  
)

export default component.exports